// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FundOutlinedSvg from "@fishx/icons-svg/es/asn/FundOutlined";
import FishxIcon from '../components/FishxIcon';

var FundOutlined = function FundOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FundOutlinedSvg
  }));
};

FundOutlined.displayName = 'FundOutlined';
export default React.forwardRef(FundOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FundOutlined.js
// module id = 2850
// module chunks = 0